// extracted by mini-css-extract-plugin
export default {"parent":"settingsCardInfo_parent__9m2s3","parentFormItem":"settingsCardInfo_parentFormItem__N5wbT"};